const changeStateFliter = function(input) {
  // 11-变更待受理12-变更待调度受理13-变更内部拒绝14-变更调度拒绝15-变更通过'
    switch (input) {
      case '11':
        return '待受理'
      case '12':
        return '待受理'
      case '13':
        return '已拒绝'
      case '14':
        return '已拒绝'
      case '15':
        return '受理通过'
    }
}
let filterObj = {}
filterObj.changeState = changeStateFliter
export default filterObj
